<!-- <ngx-spinner type="ball-scale-multiple"></ngx-spinner> -->
<ngx-spinner type="line-scale-pulse-out"></ngx-spinner>
